import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FileText, ArrowRight, Plus } from "lucide-react";

const STATUS = {
  draft: { l: "Bozza", c: "bg-slate-100 text-slate-700" },
  submitted: { l: "Inviato", c: "bg-[#EAF0FF] text-[#2D6BFF]" },
  reviewed: { l: "In revisione", c: "bg-amber-100 text-amber-700" },
  matched: { l: "Matched", c: "bg-[#E9F8F1] text-[#1F9D6A]" },
};

export default function CompanyRequests() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/assessments/").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Le tue richieste</h1>
          <p className="text-sm text-slate-600">Visualizza i check-up inviati e lo stato delle tue richieste.</p>
        </div>
        <Link to="/checkup"><Button className="bg-[#2D6BFF] text-white" data-testid="new-checkup-btn"><Plus size={16} className="mr-1" /> Nuovo check-up</Button></Link>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {items.map(a => (
          <div key={a.id} className="cxo-card p-5 flex items-center gap-4">
            <div className="w-11 h-11 rounded-lg bg-[#EAF0FF] flex items-center justify-center"><FileText size={20} className="text-[#2D6BFF]" /></div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-semibold text-slate-900">{a.recommended_role || "Check-up in corso"}</h3>
                <Badge className={`${STATUS[a.status]?.c || "bg-slate-100"} border-0`}>{STATUS[a.status]?.l || a.status}</Badge>
              </div>
              <p className="text-xs text-slate-500 mt-1">{a.company_legal_name} · {(a.challenges || []).slice(0, 2).join(", ")}</p>
            </div>
            <Link to="/app/shortlist"><Button variant="outline" size="sm">Vedi <ArrowRight size={14} className="ml-1" /></Button></Link>
          </div>
        ))}
        {!items.length && (
          <div className="cxo-card p-10 text-center">
            <p className="text-slate-500">Nessuna richiesta. <Link to="/checkup" className="text-[#2D6BFF] font-semibold">Inizia ora</Link>.</p>
          </div>
        )}
      </div>
    </div>
  );
}
